import { Empty, Modal, Spin } from 'antd'
import useNews from 'hook/useNews'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setNews } from 'store/actionReducers/NewsStore'
import './ListNew.scss'

export default function ListNew() {
  const dispatch = useDispatch();
  const [params, setParams] = useState({ stock: '', page: 0, size: 10 })
  const { fetchNews } = useNews()
  const NewsStore = useSelector((state: any) => state?.NewsStore)
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const LoadingStore = useSelector((state: any) => state?.LoadingStore)
  const [ShowNew, setShowNew] = useState<any>(false)
  const [DetailNews, setDetailNews] = useState<any>(false)

  useEffect(() => {
    dispatch(setNews([]))
    setParams({ stock: StocksAnalysisStore?.inputSearch, page: 0, size: 10 })
  }, [StocksAnalysisStore?.inputSearch]);

  useEffect(() => {
    fetchNews(params);
  }, [params]);

  const LoadMoreData = () => {
    setParams({ ...params, page: params?.page + 1 })
  }

  const handleScroll = (e: any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      LoadMoreData()
    }
  }

  const handleDetailNew = (items: any) => {
    setDetailNews(items)
    setShowNew(true)
  }

  let description = DetailNews?.newsfullcontent

  if (description) {
    description = description.replaceAll(`title="Tải về"`, `title="Tải về" target="_blank" rel="noopener"`)
  }
  return (
    <>
      <div className="DWuBGvpESB">
        <div className="QhzAsXcbjD" onClick={() => dispatch(setNews([]))}>Tin tức</div>
        <Spin spinning={LoadingStore?.loading.indexOf('news') > -1}>
          <div className="TKzXncRDgV" onScroll={(event) => handleScroll(event)}>
            {
              NewsStore?.news && NewsStore?.news.length > 0 ? NewsStore?.news?.map((item: any, key: number) => {
                return (
                  <div className="pvJtWUxCCq" key={key} onClick={() => handleDetailNew(item)}>
                    <div className="fmfAvFpLmG">{item?.newstitle}</div>
                    <div className="lSGYzDBYIH">{item?.publicdate ? moment(item?.publicdate).format('DD/MM/YYYY HH:mm') : null}</div>
                  </div>
                )
              }) : <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{
                  height: 60,
                }}
                description={
                  <span className='wlisdivjnt'>
                    Dữ liệu đang cập nhật
                  </span>
                } />
            }
          </div>
        </Spin>
        <Modal title="Chi tiết tin tức" className='zorwlgmroa' footer={false}
          visible={ShowNew} onOk={() => setShowNew(false)} onCancel={() => setShowNew(false)}>
          <h2 className='qhsllitdfp'>{DetailNews?.newstitle}</h2>
          <div className='pikcssoyrs'></div>
          <div dangerouslySetInnerHTML={{ __html: description }}>
          </div>
        </Modal>
      </div >
    </>
  )
}